import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import authimg from "../../assests/authimg.png";
import gIcon from "../../assests/gIcon.png";
import { useAuthStore } from "../../store/useAuthStore";
import Loader from "../../components/Loader/Loader";

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    fullname: '',
    password: '',
    confirmPassword: '',
  });
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const { registerUser, loading } = useAuthStore()
  const navigate = useNavigate()

  const validateForm = () => {
    let newErrors = {};
    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email is invalid';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // for phone number validation 
  const [message, setMessage] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    const data = {
      ...formData,
      email
    }

    try {
      const res = await registerUser(data)
      if (res) {
        navigate("/login")
      }
    } catch (error) {
      console.log(error)
    }
    console.log("success", data);

  };

  return (
    <Box sx={{ padding: "40px 0 60px" }}>
      <Loader loading={loading} />
      <Container maxWidth="xl">
        <Grid
          container
          sx={{ width: "100%" }}
          columnSpacing={{ xs: 1, sm: 2, md: 2 }}
        >
          <Grid item size={{ xs: 12, sm: 12, md: 7 }}>
            <Box
              sx={{
                padding: "20px 80px 0px 0",
                "& img": {
                  maxWidth: "100%",
                  display: "block",
                },
              }}
            >
              <img src={authimg} alt="auth-image" />
            </Box>
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 5 }}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box sx={{
              width: "80%",
            }}>
              <Typography
                sx={{
                  fontSize: "36px",
                  lineHeight: "30px",
                  fontWeight: "700",
                  fontFamily: `"Quicksand", sans-serif`,
                  color: "#000",
                  // marginTop: "80px",
                  "& span": {
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    display: "block",
                  },
                }}
              >
                Create an account
                <span>Enter your details below</span>
              </Typography>
              <Box
                component="form"
                sx={{
                  marginTop: "20px",
                  "& label": {
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "400",
                    fontFamily: `"Lato", sans-serif`,
                    color: "#000",
                  },
                  "& .MuiFormControl-root": {
                    width: "100%",
                  },
                  "& input::placeholder": {
                    color: "#999999",
                  },
                }}
                noValidate
                // autoComplete="off"
                onSubmit={onSubmit}
              >
                <TextField
                  id="standard-basic"
                  label="Username"
                  type="text"
                  variant="standard"
                  name="username"
                  required
                  onChange={handleChange}
                />
                <TextField
                  id="standard-basic"
                  label="Full Name"
                  type="text"
                  variant="standard"
                  name="fullname"
                  required
                  onChange={handleChange}
                />
                <TextField
                  id="standard-basic"
                  label="Email"
                  type="email"
                  variant="standard"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}

                <TextField
                  id="standard-basic"
                  label="Password"
                  type="password"
                  variant="standard"
                  name="password"
                  required
                  onChange={handleChange}
                />
                <TextField
                  id="standard-basic"
                  label="Confirm Password"
                  type="password"
                  variant="standard"
                  name="confirmPassword"
                  required
                  onChange={handleChange}
                />
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    display: "block",
                    textAlign: "center",
                    background: "#008BFF",
                    width: "100%",
                    height: { xs: "36px", sm: "36px", md: "45px", lg: "56px" },
                    margin: "30px auto 10px",
                    borderRadius: "4px",
                    color: "#FAFAFA",
                    boxShadow: "none",
                    fontFamily: `"Quicksand", sans-serif`,
                    fontWeight: 500,
                    fontSize: {
                      xs: "12px",
                      sm: "15px",
                      md: "15px",
                      lg: "16px",
                    },
                    lineHeight: {
                      xs: "18px",
                      sm: "20px",
                      md: "22px",
                      lg: "24px",
                    },
                    textTransform: "capitalize",
                  }}
                >
                  Create Account
                </Button>
                {/* <Button
                  variant="contained"
                  sx={{
                    display: "block",
                    textAlign: "left",
                    background: "transparent",
                    paddingLeft: "100px",
                    width: "100%",
                    height: { xs: "36px", sm: "36px", md: "45px", lg: "56px" },
                    marginBottom: "30px",
                    borderRadius: "4px",
                    border: "1px solid rgba(0, 0, 0, 0.4)",
                    color: "#000",
                    boxShadow: "none",
                    fontFamily: `"Quicksand", sans-serif`,
                    fontWeight: 500,
                    fontSize: {
                      xs: "12px",
                      sm: "15px",
                      md: "15px",
                      lg: "16px",
                    },
                    lineHeight: {
                      xs: "18px",
                      sm: "20px",
                      md: "22px",
                      lg: "24px",
                    },
                    textTransform: "capitalize",
                    "& span": {
                      display: "flex",
                      alignItems: "center",
                    },
                    "& span img": {
                      marginRight: "20px",
                    },
                  }}
                >
                  <span>
                    <img src={gIcon} />
                    Sign up with Google
                  </span>
                </Button> */}
                <Typography
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "500",
                    fontFamily: `"Quicksand", sans-serif`,
                    color: "#000",
                    "& a": {
                      fontSize: "16px",
                      lineHeight: "24px",
                      marginLeft: "30px",
                      textDecoration: "underline",
                    },
                  }}
                >
                  Already have account?
                  <Link to="/login">Log in</Link>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Register;
